// App.js or Routes.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from "./Components/Login";
import Endowment from "./Components/Endownment2";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/endowment" element={<Endowment />} />
    </Routes>
  );
}

export default App;
